import axios from 'axios'

export default {
    data() {
        return {}
    },
    methods: {
        isPlaceValid(place) {
            let count = 0
            place.address_components.forEach((component) => {
                if (
                    component.types.includes('locality') ||
                    component.types.includes('postal_town') || //English case
                    component.types.includes('country') ||
                    component.types.includes('postal_code') ||
                    component.types.includes('plus_code')
                ) {
                    count++
                }
            })
            return count >= 3
        },

        isPlaceComplete(place) {
            let count = 0
            place.address_components.forEach((component) => {
                if (
                    component.types.includes('street_number') ||
                    component.types.includes('route') ||
                    component.types.includes('locality') ||
                    component.types.includes('postal_town') || //English case
                    component.types.includes('country') ||
                    component.types.includes('postal_code')
                ) {
                    count++
                }
            })
            return count >= 5
        },

        buildApiDomicileObject(place, additional_information) {
            let domicile_model = {}

            if (place.id_domicile) {
                domicile_model = {
                    id_google_place: place.place_id,
                    id_domicile: place.id_domicile,
                }
            } else {
                domicile_model = {
                    id_google_place: place.place_id,
                    country: '',
                    reference: '',
                    country_code: '',
                    plus_code: '',
                    latitude: '',
                    locality: '',
                    longitude: '',
                    postal_code: '',
                    route: '',
                    street_number: '',
                    address2: !place.formatted_address.includes(place.name) ? place.name : '',
                    complement: !place.formatted_address.includes(place.name) ? place.name : '',
                }

                place.address_components.forEach((component) => {
                    if (component.types.includes('locality') || component.types.includes('postal_town')) {
                        domicile_model.locality = component.long_name
                    } else if (component.types.includes('country')) {
                        domicile_model.country = component.long_name
                        domicile_model.country_code = component.short_name
                    } else if (component.types.includes('postal_code')) {
                        domicile_model.postal_code = component.long_name
                    } else if (component.types.includes('plus_code')) {
                        domicile_model.plus_code = component.long_name
                    }
                })

                if (this.isPlaceComplete(place)) {
                    place.address_components.forEach((component) => {
                        if (component.types.includes('street_number')) {
                            domicile_model.street_number = component.long_name
                            domicile_model.number = component.long_name
                        } else if (component.types.includes('route')) {
                            domicile_model.route = component.long_name
                            domicile_model.address = component.long_name
                        }
                    })
                } else {
                    domicile_model.route = place.formatted_address.substring(0, place.formatted_address.indexOf(','))
                }

                if (typeof place.geometry.location.lat === 'number') {
                    //Google map
                    domicile_model.latitude = place.geometry.location.lat
                    domicile_model.longitude = place.geometry.location.lng
                } else {
                    //Google autocomplete
                    domicile_model.latitude = place.geometry.location.lat()
                    domicile_model.longitude = place.geometry.location.lng()
                }
            }

            return { ...domicile_model, ...additional_information }
        },
    },
}
